import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfAuth } from './getExploreContent200PageAllOfThreeContentItemContentOneOfAuth';
import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfAuthor } from './getExploreContent200PageAllOfThreeContentItemContentOneOfAuthor';
import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfBasicInfo } from './getExploreContent200PageAllOfThreeContentItemContentOneOfBasicInfo';
import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfEngagement } from './getExploreContent200PageAllOfThreeContentItemContentOneOfEngagement';
import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfMedia } from './getExploreContent200PageAllOfThreeContentItemContentOneOfMedia';
import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfPoll } from './getExploreContent200PageAllOfThreeContentItemContentOneOfPoll';
import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweet } from './getExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweet';
import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfTags } from './getExploreContent200PageAllOfThreeContentItemContentOneOfTags';
import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfUserInteraction } from './getExploreContent200PageAllOfThreeContentItemContentOneOfUserInteraction';

export type GetExploreContent200PageAllOfThreeContentItemContentOneOf = {
  /** 인증 컨텍스트 정보 */
  auth?: GetExploreContent200PageAllOfThreeContentItemContentOneOfAuth;
  /** 트윗 작성자 정보 */
  author?: GetExploreContent200PageAllOfThreeContentItemContentOneOfAuthor;
  basicInfo?: GetExploreContent200PageAllOfThreeContentItemContentOneOfBasicInfo;
  engagement?: GetExploreContent200PageAllOfThreeContentItemContentOneOfEngagement;
  /** 미디어 정보 */
  media?: GetExploreContent200PageAllOfThreeContentItemContentOneOfMedia;
  /** 트윗에 포함될 투표 정보 (선택 사항) */
  poll?: GetExploreContent200PageAllOfThreeContentItemContentOneOfPoll;
  /** 참조된 트윗 정보 (답글, 인용, 리트윗인 경우) */
  referencedTweet?: GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweet;
  /** 트윗 태그 정보 */
  tags?: GetExploreContent200PageAllOfThreeContentItemContentOneOfTags;
  /** 사용자 상호작용 정보 */
  userInteraction?: GetExploreContent200PageAllOfThreeContentItemContentOneOfUserInteraction;
};
